/**
 * A count whose digits roll to their new value (board E's `.roll`): the counter „Rozwiązane n z N"
 * and the program card's figures. Each digit is a column of 0 to 9 moved by a transform, so a
 * change never lays anything out again; the reduced-motion block in `tokens/base.css` collapses it.
 * The columns are decoration: the number itself is read as text.
 */

import type { CSSProperties } from 'react';

import hidden from '~/shared/ui/visuallyHidden.module.css';

import styles from './RollingNumber.module.css';

const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export function RollingNumber({ value }: { readonly value: number }) {
  const text = String(Math.max(0, Math.trunc(value)));
  return (
    <span>
      <span className={styles.number} aria-hidden="true">
        {[...text].map((digit, index) => (
          // Keyed from the right, so the ones keep their column when the number gains a digit.
          <span key={text.length - index} className={styles.window}>
            <span className={styles.column} style={{ '--roll-digit': digit } as CSSProperties}>
              {DIGITS.map((each) => (
                <span key={each} className={styles.digit}>
                  {each}
                </span>
              ))}
            </span>
          </span>
        ))}
      </span>
      <span className={hidden.srOnly}>{text}</span>
    </span>
  );
}
